import { render, staticRenderFns } from "./HeadNavHomeSchool.vue?vue&type=template&id=bffa4d68&scoped=true&"
import script from "./HeadNavHomeSchool.vue?vue&type=script&lang=js&"
export * from "./HeadNavHomeSchool.vue?vue&type=script&lang=js&"
import style0 from "./HeadNavHomeSchool.vue?vue&type=style&index=0&id=bffa4d68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa4d68",
  null
  
)

export default component.exports